<ng-template #subscribeModal>
  <app-subscribe-form
    [showCloseBtn]="false"
    [emailDisabled]="true"
    [email]="email!"
    [wallet]="wallet!"
    [notifyOnUnlock]="notifyOnUnlock ||false"
    [monthlySummary]="monthlySummary || false"
    (onSave)="onSave($event)"
  ></app-subscribe-form>
</ng-template>


<app-loader [isLoading]="isLoading"></app-loader>
